<script>
import {mapState} from 'vuex'
import FullCalendar from "@fullcalendar/vue";
import FullCalendarHandler from "../../../common/mixins/FullCalendarHandler.vue";

export default {
    name: 'PlannedTasksFullCalendar',

    components: {
        FullCalendar
    },

    mixins: [FullCalendarHandler],

    data() {
        return {
            attributes: [],
            plannedTasks: [],
            bankHolidays: [],
            absences: [],
            links: [],
            meta: [],
            showCalendar: true,
            loading: false,
            dayLabel: '',
            dayTasks: [],
            dayDuration: 0,
        }
    },

    computed: {
        ...mapState({
            filters: (state) => state.reportingVM.filters,
            clientsActivationFilter: (state) => state.browsing.clientsActivationFilter

        }),
        accountingFirmUserIsSet() {
            return this.filters.accountingFirmUser > 0
        }

    },

    created() {
        this.$store.commit('browsing/SET_PAGE_NAME', 'plannedTasks')
    },

    async mounted() {
        await this.getItems()
    },

    methods: {
        goTo(customData) {
            this.$store.commit('browsing/SET_YEAR', customData.year)
            this.$store.commit('reportingVM/SET_SEARCH', customData.client_name)
            window.location.href = customData.url
        },

        async getItems() {
            if (this.accountingFirmUserIsSet) {
                try {
                    this.loading = true
                    const response = await axios.get(
                        `/reporting/plannedTasks/${this.year}/${this.month}/${this.filters.accountingFirmUser}`
                    )
                    this.plannedTasks = response.data.data.plannedTasks.data
                    this.bankHolidays = response.data.data.bankHolidays.data
                    this.absences = response.data.data.absences.data
                    this.links = response.data.data.links.data
                    this.setEvents()
                    // this.meta = response.data.meta
                    this.loading = false
                } catch (error) {
                    console.log(error)
                    this.handleErrors(error.response)
                }
            } else {
                this.attributes = []
            }
        },

        setEvents() {
            this.calendarOptions.events = this.links.concat(this.bankHolidays.concat(this.absences.concat(this.plannedTasks)))
        },

        handleErrors(errorResponse) {
            this.loading = false
            this.errorMessage =
                "Une erreur s'est produite, les données n'ont pu être chargées. Veuillez réactualiser la page."
            this.hasErrors = true
        },

        handleClick(day) {
            console.log('handleClick', day)
            this.dayLabel = day.label
            this.dayTasks = this.plannedTasks.filter(item => item.start === day.id)
            this.dayDuration = this.dayTasks.reduce((total, item) => total + item.duration, 0);
            this.showCalendar = false
        },

        backToCalendar() {
            this.showCalendar = true
        }
    },
}
</script>

<template>
    <div class="w-100">

        <div>
            <div v-if="!accountingFirmUserIsSet">
                <b-alert variant="warning" show>
                    Vous devez sélectionner un collaborateur pour afficher son planning
                </b-alert>
            </div>
            <div v-if="showCalendar">
                <full-calendar ref="myFullCalendar" :options="calendarOptions"/>
            </div>
            <div v-else>
                <div class="d-flex justify-content-between align-items-center">
                    <h3 class="mb-3">Tâches planifiées le {{ dayLabel }}</h3>
                    <b-btn variant="primary" size="sm" @click="backToCalendar">
                        <i class="fas fa-fw fa-calendar mr-2"/>Vue mensuelle
                    </b-btn>
                </div>

                <table class="table">
                    <thead>
                    <tr>
                        <th>Client</th>
                        <th>Action</th>
                        <th>A faire avant</th>
                        <th class="text-right">Durée</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="task in dayTasks" :key="task.key">
                        <td>{{ task.customData.client_name }}</td>
                        <td>{{ task.customData.action_title }}</td>
                        <td>
                            {{ task.customData.deadline_date }}
                            <b-badge v-if="task.status!=='future'"
                                     class="ml-2"
                                     :style="'background-color: ' + task.customData.badge_color + ';'">
                                {{ task.customData.badge_legend }}
                            </b-badge>
                        </td>
                        <td class="text-right number-font">{{ task.duration.toFixed(2) }}&nbsp;h</td>
                    </tr>
                    </tbody>
                    <tfoot>
                    <tr>
                        <th colspan="3" class="text-uppercase">Total journée</th>
                        <th class="text-right number-font">{{ dayDuration.toFixed(2) }}&nbsp;h</th>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>


<style scoped>
.pointer-style {
    cursor: pointer;
}
</style>
